export default __webpack_public_path__ + "static/media/process3.82e39344.svg";